exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2Kxdq0WoVcRY9M{padding:0;position:relative;margin:0 0 8px 40px}._3WCMYKlBFLSCxE{margin:0}._19bffj3SpWysf_{left:-40px;padding:4px;position:absolute;top:2px}._3--lXz83AQn7GH{display:grid;grid-template-columns:1fr 1fr;grid-column-gap:16px;grid-row-gap:16px}._3gL_XBulEWv-j6{color:#5e6c84;font-size:12px;line-height:16px}._3todZRLSSVKT-X{-webkit-filter:brightness(0) invert(1);filter:brightness(0) invert(1)}._1mJjwV7bGSv0l7{justify-content:space-between}._1mJjwV7bGSv0l7,._2Uvqq0zzsL2HRR,._13qd-n3GHmealq{align-items:center;display:flex}._13qd-n3GHmealq{height:32px;justify-content:center;margin:0 0 0 8px;max-height:32px}._2qTxMosYquewAo{background-color:#0061ff;color:#fff}._2qTxMosYquewAo ._3todZRLSSVKT-X{margin-right:8px}._2qTxMosYquewAo:hover{background-color:#0052d9}._2qTxMosYquewAo:active{background-color:#0046ba}._1m-fCe0J52aUxE{width:32px;background-color:rgba(9,30,66,.04)}._1m-fCe0J52aUxE:hover{background-color:rgba(9,30,66,.08)}._1m-fCe0J52aUxE:active,._1m-fCe0J52aUxE:focus{background-color:#e4f0f6}", ""]);

// exports
exports.locals = {
	"moduleTitleBlock": "_2Kxdq0WoVcRY9M",
	"moduleTitle": "_3WCMYKlBFLSCxE",
	"dropboxMark": "_19bffj3SpWysf_",
	"attachmentsGrid": "_3--lXz83AQn7GH",
	"sectionMeta": "_3gL_XBulEWv-j6",
	"whiteDropboxMark": "_3todZRLSSVKT-X",
	"headerContent": "_1mJjwV7bGSv0l7",
	"headerActions": "_2Uvqq0zzsL2HRR",
	"headerBtn": "_13qd-n3GHmealq",
	"enableDropboxBtn": "_2qTxMosYquewAo",
	"dismissBtn": "_1m-fCe0J52aUxE"
};